// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__KyfA1","inputWrap":"CustomTip_inputWrap__2KVtS"};